import { useEffect } from 'react';

// Detecta o ambiente pela URL da API embutida no build:
// homologacao => a URL contem "hmg" (api.hmg.promatec...); producao => nao contem.
// Assim o indicador so aparece em HMG e nunca em producao, sem depender de flag extra.
const IS_HMG = (process.env.REACT_APP_BACKEND_URL || '')
  .toLowerCase()
  .includes('hmg');

const COR = '#f59e0b'; // ambar (distinto do vermelho da marca)

/**
 * Marcador visual do ambiente de HOMOLOGACAO: moldura ao redor da tela + selo no
 * canto, e prefixo "[HMG]" no titulo da aba. Nao renderiza nada em producao.
 * Tudo com pointer-events: none para nunca bloquear cliques.
 */
export const EnvBadge = () => {
  useEffect(() => {
    if (IS_HMG && !document.title.startsWith('[HMG]')) {
      document.title = `[HMG] ${document.title}`;
    }
  }, []);

  if (!IS_HMG) return null;

  return (
    <>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          border: `3px solid ${COR}`,
          pointerEvents: 'none',
          zIndex: 3000,
        }}
      />
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          backgroundColor: COR,
          color: '#000',
          fontWeight: 700,
          fontSize: 12,
          letterSpacing: 1,
          padding: '4px 12px',
          borderBottomLeftRadius: 8,
          pointerEvents: 'none',
          zIndex: 3001,
          boxShadow: '0 1px 4px rgba(0,0,0,.3)',
        }}
      >
        HOMOLOGAÇÃO
      </div>
    </>
  );
};

export default EnvBadge;
